module.exports = __webpack_public_path__ + "static/media/photo29.81a99c8f.jpg";